import { Point } from 'ol/geom'
import { transform } from 'ol/proj'
import { ALERT_MOB_MESSAGE_RECEIVED_EVENT_TYPE } from '../../plugins/utils/events'
import { toast } from 'vue3-toastify'

export default class ManOverBoard {
  constructor(map) {
    this.map_ = map
  }

  start() {
    document.addEventListener(ALERT_MOB_MESSAGE_RECEIVED_EVENT_TYPE, this.alertMob.bind(this))
  }

  stop() {
    document.removeEventListener(ALERT_MOB_MESSAGE_RECEIVED_EVENT_TYPE, this.alertMob.bind(this))
  }

  alertMob(e) {
    const { detail } = e
    const callback = () => {
      if (Number(detail.longitude) !== 0 && Number(detail.latitude !== 0)) {
        setTimeout(() => {
          const coords = [Number(detail.longitude), Number(detail.latitude)]
          const coordsT = transform(coords, 'EPSG:4326', 'EPSG:3857')
          const geom = new Point(coordsT)
          this.map_.getView().fit(geom, { size: this.map_.getSize(), duration: 500, maxZoom: 12 })
        }, 5000)
      }
    }
    toast(`<div class="mobInfo">MAN OVER BOARD ALERT !! <br>MMSI: ${detail.mmsi}<br>Name: ${detail.name}</div>`, {
      dangerouslyHTMLString: true,
      closeOnClick: false,
      autoClose: 30000,
      onOpen: () => callback()
    })
  }
}